import React from 'react';
import { UserPaymentWithItemPrice } from '../../../../../../../api/types/students/payment-services/user-payments/user-payment-service-with-price-list';

export interface PaymentSummaryProps {
  payments: UserPaymentWithItemPrice[];
  totalPrice: number;
  installmentAmount?: number;
}
export const PaymentSummary: React.FC<PaymentSummaryProps> = ({
  payments,
  totalPrice,
  installmentAmount = 0,
}) => {
  const totalPaid =
    payments?.reduce((sum, payment) => sum + payment.itemAmount, 0) || 0;
  const remaining = totalPrice - totalPaid - installmentAmount;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <label style={{ fontWeight: 'bold', fontSize: '20px' }}>
        היסטוריית תשלומים
      </label>
      <div
        className="payment-summary"
        style={{
          display: 'flex',
          gap: '1rem',
          padding: '0.5rem 1rem',
          backgroundColor: 'white',
          borderRadius: '8px',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            minWidth: '150px',
          }}
        >
          <i
            className="pi pi-check-circle"
            style={{ color: '#00C853', fontSize: '1.2rem' }}
          />
          <div>
            <div style={{ color: '#666', fontSize: '0.875rem' }}>שולם</div>
            <div
              style={{
                color: '#00C853',
                fontWeight: 'bold',
                fontSize: '1.1rem',
              }}
            >
              ₪{totalPaid.toLocaleString()}
            </div>
          </div>
        </div>

        <div
          style={{
            width: '1px',
            height: '40px',
            backgroundColor: '#e0e0e0',
          }}
        />

        {installmentAmount > 0 && (
          <>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                minWidth: '150px',
              }}
            >
              <i
                className="pi pi-calendar"
                style={{ color: '#1976D2', fontSize: '1.2rem' }}
              />
              <div>
                <div style={{ color: '#666', fontSize: '0.875rem' }}>
                  בהוראות קבע
                </div>
                <div
                  style={{
                    color: '#1976D2',
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                  }}
                >
                  ₪{installmentAmount.toLocaleString()}
                </div>
              </div>
            </div>

            <div
              style={{
                width: '1px',
                height: '40px',
                backgroundColor: '#e0e0e0',
              }}
            />
          </>
        )}

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            minWidth: '150px',
          }}
        >
          <i
            className="pi pi-clock"
            style={{
              color: remaining > 0 ? '#FF9800' : '#00C853',
              fontSize: '1.2rem',
            }}
          />
          <div>
            <div style={{ color: '#666', fontSize: '0.875rem' }}>
              {remaining > 0 ? 'נותר לתשלום' : 'מסודר'}
            </div>
            <div
              style={{
                color: remaining > 0 ? '#FF9800' : '#00C853',
                fontWeight: 'bold',
                fontSize: '1.1rem',
              }}
            >
              ₪{Math.max(0, remaining).toLocaleString()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
